import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

//-------------------------------------------------------------------------------------------------------------------

class Layout extends Component {

    render() {
        const { accountInfo } = this.props;

        return (
            
            <main>

                <div className="logo-container">

                    <img src="/images/logo.png" />

                    {accountInfo && !!accountInfo.landlineTel && 
                        <a className="account-info" href={`tel:${accountInfo.landlineTel}`}>
                            Problems or questions?
                            <br />
                            Call {accountInfo.landlineTel}
                        </a>
                    }
                    
                </div>

                <div className="main-content">

                    {this.props.children}

                </div>

            </main>

        );
    }
}

export default withRouter(Layout);